import { serverFetch } from "@core/server";

export function fetchDocPlatList({
  dateBeg,
  dateEnd,
  sortBy,
  sortDir,
  showDeleted = false,
  idKassa = 0,
  vid = 0,
  q,
  skip = 0,
  take = 50
} = {}) {
  return serverFetch("doc-plat", {
    queryParams: {
      skip,
      take,
      showDeleted: showDeleted ? 1 : 0,
      ...(idKassa > 0 ? { idKassa } : {}),
      ...(vid ? { vid } : {}),
      ...(q ? { q } : {}),
      ...(dateBeg ? { dateBeg } : {}),
      ...(dateEnd ? { dateEnd } : {}),
      ...(sortBy ? { sortBy } : {}),
      ...(sortDir ? { sortDir } : {})
    }
  });
}

export function fetchDocPlat(id) {
  return serverFetch(`doc-plat/${id}`);
}

export function fetchDocPlatLookups() {
  return serverFetch("doc-plat/lookups");
}

export function fetchDocPlatNextDocnum({ idKassa, vid, fdate } = {}) {
  return serverFetch("doc-plat/next-docnum", {
    queryParams: {
      idKassa,
      vid,
      ...(fdate ? { fdate } : {})
    }
  });
}

export function createDocPlat(bodyData) {
  return serverFetch("doc-plat", { method: "POST", bodyData });
}

export function saveDocPlat(bodyData) {
  return serverFetch("doc-plat", { method: "PUT", bodyData });
}

export function deleteDocPlat(id) {
  return serverFetch(`doc-plat/${id}`, { method: "DELETE" });
}
